import Vue from "vue"
import Vuex from "vuex"
import app from '@/features/app/store'
import contacts from '@/features/contacts/store'
import pages from '@/features/pages/store'
import products from '@/features/products/store'

Vue.use(Vuex)
export default new Vuex.Store({
	strict: process.env.NODE_ENV === 'development',
	actions: {		
		async init({ dispatch, commit }) {	
			await Promise.all([
				dispatch('appVersionsLoad'),
				dispatch('pagesSnippetsLoad'),
				dispatch('pagesLoad'),
				dispatch('productsLoad'),
				dispatch('productsBrandsLoad')
			])
			dispatch('appSetLoaded')			
		}
	},
	modules: { 
		app,	
		contacts,	
		pages,
		products
	}
})
